import { render, staticRenderFns } from "./nzxt-bld-services.vue?vue&type=template&id=55a94c7d&scoped=true&"
import script from "./nzxt-bld-services.vue?vue&type=script&lang=js&"
export * from "./nzxt-bld-services.vue?vue&type=script&lang=js&"
import style0 from "./nzxt-bld-services.vue?vue&type=style&index=0&id=55a94c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a94c7d",
  null
  
)

export default component.exports